// wishlist.js
document.addEventListener('DOMContentLoaded', function() {
  /* Add to wishlist start */
  document.querySelectorAll('.wishlist-button').forEach(function(button) {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      var productId = button.dataset.productId;

      // Check if localStorage is available
      if (typeof Storage !== 'undefined') {
        // Retrieve existing wishlist or create an empty array
        var wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

        // Check if the product is not already in the wishlist
        if (wishlist.indexOf(productId) === -1) {
          // Add the product to the wishlist
          wishlist.push(productId);

          // Update the localStorage with the new wishlist
          localStorage.setItem('wishlist', JSON.stringify(wishlist));

          // Optionally, you can provide user feedback here (e.g., alert, notification)
          alert('Product added to wishlist!');
        } else {
          alert('Product is already in the wishlist!');
        }
      } else {
        console.error('LocalStorage is not supported!');
      }
    });
  });
  /* Add to wishlist End */

  
});

document.addEventListener('load', function() {
/* Remove from wishlist Start */
  var removeFromWishlistButtons = document.querySelectorAll('.remove-from-wishlist');
console.log(removeFromWishlistButtons);
    removeFromWishlistButtons.forEach(function(button) { 
        button.addEventListener('click', function(event) {
            var productId = button.dataset.productId;
alert(productId);
            // Perform AJAX request to remove product from wishlist
            var formData = new FormData();
            formData.append('id', productId);

            fetch('/wishlist/remove', {
                method: 'POST',
                body: formData
            })
            .then(response => {
                if (response.ok) {
                    // Product successfully removed from wishlist
                    // Optionally, you can update the UI to reflect the change
                    button.parentElement.remove(); // Remove the product from the DOM
                    alert('Product removed from wishlist!');
                } else {
                    // Error occurred while removing product from wishlist
                    alert('Error removing product from wishlist!');
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
        });
    });
  /* Remove from wishlist End */
});
